import { z } from 'zod'

const schema = z.object({
  VITE_SUPABASE_URL: z.string().url().optional(),
  VITE_SUPABASE_ANON_KEY: z.string().optional(),
  VITE_API_URL: z.string().default('http://localhost:8787'),
})

const parsed = schema.safeParse(import.meta.env)

export const env = parsed.success
  ? parsed.data
  : {
      VITE_SUPABASE_URL: undefined,
      VITE_SUPABASE_ANON_KEY: undefined,
      VITE_API_URL: 'http://localhost:8787',
    }

export const hasSupabase = Boolean(env.VITE_SUPABASE_URL && env.VITE_SUPABASE_ANON_KEY)
